import React, { useState } from "react";
import { COLORS } from "../utils/constants";
import { useOtpVerification } from "../utils/OTP/useOtpVerification";
import { OtpInput } from "../utils/OTP/OtpInput";
import { submitContactForm, ContactPayload } from "../utils/API/contactApi";

interface ContactPageProps {
  content: any;
}

const ContactPage: React.FC<ContactPageProps> = ({ content }) => {
  const [status, setStatus] = useState<"idle" | "submitting" | "success">(
    "idle"
  );
  const {
    sendOtp,
    verifying,
    showOtp,
    otp,
    otpRefs,
    handleOtpChange,
    validateOtp,
  } = useOtpVerification();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus("submitting");

    const form = e.currentTarget;
    const formData = new FormData(form);
    const payload = {
      name: formData.get("name") as string,
      email: formData.get("email") as string,
      phone: formData.get("whatsapp") as string,
      //website: formData.get("website") as string,
      message: formData.get("goals") as string,
      inquerytype: formData.get("service") as string,
    };

    try {
      await submitContactForm(payload);
      setStatus("success");
      //e.currentTarget.reset();
    } catch (err: any) {
      //alert(err.message || "Something went wrong");
      console.log(err.message || "Something went wrong");
      setStatus("idle");
    }
  };

  if (status === "success") {
    return (
      <div style={{ padding: "32px 6%", textAlign: "center" }}>
        <h2 style={{ color: COLORS.brandTeal }}>{content.successTitle}</h2>
        <p>{content.successSub}</p>
        <button
          onClick={() => setStatus("idle")}
          style={{
            ...btnStyle,
            background: "none",
            border: `1px solid ${COLORS.brandPurple}`,
            padding: "8px 20px",
            cursor: "pointer",
            marginTop: "20px",
            color: COLORS.brandPurple,
          }}
        >
          {content.backBtn}
        </button>
      </div>
    );
  }

  return (
    <section
      id="contact"
      style={{
        padding: "8px 5% 24px",
        background:
          "linear-gradient(135deg, rgba(1,126,132,0.03), transparent)",
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "1.5fr 1fr",
          gap: "40px",
        }}
      >
        {/* LEFT COLUMN */}
        <div>
          <h1
            style={{
              color: COLORS.brandPurple,
              fontSize: "2.2rem",
              marginBottom: "8px",
              marginTop: "0",
              fontWeight: 800,
            }}
          >
            {content.title}
          </h1>

          <p
            style={{
              color: "#666",
              marginBottom: "20px",
              marginTop: "0",
              fontSize: "0.95rem",
            }}
          >
            {content.subtitle}
          </p>

          <form
            onSubmit={handleSubmit}
            style={{ display: "grid", gap: "12px" }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "12px",
              }}
            >
              <input
                name="name"
                type="text"
                placeholder={content.name}
                required
                disabled={status === "submitting"}
                style={inputStyle}
              />
              <div style={{ position: "relative" }}>
                <input
                  name="email"
                  type="email"
                  placeholder={content.email}
                  required
                  disabled={status === "submitting"}
                  style={{ ...inputStyle, paddingRight: "70px" }}
                />

                <span
                  onClick={sendOtp}
                  style={{
                    position: "absolute",
                    right: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    fontSize: "0.7rem",
                    color: COLORS.brandTeal,
                    fontWeight: 800,
                    cursor: verifying ? "not-allowed" : "pointer",
                    textDecoration: "underline",
                    userSelect: "none",
                    opacity: verifying ? 0.6 : 1,
                  }}
                >
                  {verifying ? "..." : content.verify || "Verify"}
                </span>
              </div>
              {showOtp && (
                <OtpInput
                  otp={otp}
                  otpRefs={otpRefs}
                  onChange={handleOtpChange}
                  onValidate={validateOtp}
                  onResend={sendOtp}
                />
              )}
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "12px",
              }}
            >
              <input
                name="whatsapp"
                type="text"
                placeholder={content.whatsapp}
                disabled={status === "submitting"}
                style={inputStyle}
              />
              <input
                name="website"
                type="text"
                placeholder={content.website}
                disabled={status === "submitting"}
                style={inputStyle}
              />
            </div>

            <select
              name="service"
              required
              disabled={status === "submitting"}
              style={{ ...inputStyle, height: "38px" }}
            >
              <option value="">{content.servicePlaceholder}</option>
              {(content.serviceOptions || [
                "New Feature",
                "SEO Strategy",
                "Paid Ads (Meta/Google)",
                "Content Marketing",
                "1-on-1 Consultation",
              ]).map((opt: string, i: number) => (
                <option key={i} value={serviceOptionValues[i]}>
                  {opt}
                </option>
              ))}
            </select>

            <textarea
              name="goals"
              placeholder={content.goalsPlaceholder}
              required
              disabled={status === "submitting"}
              style={{
                ...inputStyle,
                height: "100px",
                resize: "none",
                paddingTop: "10px",
              }}
            />

            <button
              type="submit"
              disabled={status === "submitting"}
              style={btnStyle}
            >
              {status === "submitting"
                ? content.sending || "Sending..."
                : content.submitBtn}
            </button>
          </form>
        </div>

        {/* RIGHT COLUMN */}
        <div
          style={{
            backgroundColor: "#f9fafb",
            padding: "20px",
            borderRadius: "12px",
            alignSelf: "start",
          }}
        >
          <h3
            style={{
              color: COLORS.brandPurple,
              marginBottom: "10px",
              marginTop: 0,
            }}
          >
            {content.sidebarTitle}
          </h3>

          <div style={infoBlock}>
            <strong>📍 {content.locationLabel || "Location"}:</strong> Mayur
            Vihar, New Delhi
          </div>
          <div style={infoBlock}>
            <strong>💬 {content.whatsappLabel || "WhatsApp"}:</strong>{" "}
            <a
              href="tel:+918447165274"
              style={{ color: COLORS.brandTeal, textDecoration: "none" }}
            >
              +91 8447 165 274
            </a>
          </div>
          <div style={infoBlock}>
            <strong>✉️ {content.emailLabel || "Email"}:</strong>{" "}
            avalancheindia999@gmail.com
          </div>
        </div>
      </div>
    </section>
  );
};

const serviceOptionValues = [
  "feature",
  "seo",
  "ads",
  "content",
  "consultation",
];

const inputStyle: React.CSSProperties = {
  width: "100%",
  padding: "8px 12px",
  borderRadius: "6px",
  border: "1px solid #ddd",
  fontSize: "0.9rem",
  outlineColor: "#017E84",
  height: "38px",
  boxSizing: "border-box",
};

const btnStyle: React.CSSProperties = {
  backgroundColor: "#017E84",
  color: "white",
  padding: "10px",
  borderRadius: "6px",
  border: "none",
  fontWeight: 700,
  cursor: "pointer",
  fontSize: "0.9rem",
};

const infoBlock = {
  marginBottom: "12px",
  fontSize: "0.9rem",
};

export default ContactPage;
